export class SlowStock {
    stockId: number
    description: string
    code: string
    soh: number
    brandId: number
    brand: string
    clientId: number
    client: string
    price: number
    image: string
}